module.exports = __webpack_public_path__ + "img/Group 522t3.d9a571db.svg";